<ng-container *ngIf="loading; else content">
  <app-loader text="Моля изчакайте..."></app-loader>
</ng-container>

<ng-template #content>
  <app-modal [padding]="'lg'">
    <form [formGroup]="form" (ngSubmit)="onSubmit($event)">
      <app-modal-header [showCloseButton]="true"
                        [title]="'Подаване на сигнал'"
                        [centerTitle]="true" (closed)="closeModal()">
      </app-modal-header>

      <div class="card basic-tab-sect">
        <div class="card-body">
          <ul ngbNav #nav="ngbNav" [activeId]="1" class="nav-tabs">
            <li [ngbNavItem]="1">
              <a ngbNavLink>Основна Информация</a>
              <ng-template ngbNavContent>
                <app-modal-body>

                  <!-- Signal requestor form fields -->
                  <ng-container *ngIf="isUserDispatcher">
                    <section class="row signal-requestor-wrapper">
                      <h4>Подател на сигнал</h4>
                      <div class="col">
                        <div class="row mb-3">
                          <div>
                            <label class="col-form-label">Тел: <span class="font-danger">*</span></label>
                            <div class="phone-wrapper">
                              <ngx-intl-tel-input [cssClass]="'phone-input'"
                                                  [enableAutoCountrySelect]="true"
                                                  [enablePlaceholder]="true"
                                                  [searchCountryFlag]="true"
                                                  [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name, SearchCountryField.DialCode]"
                                                  [selectFirstCountry]="false"
                                                  [selectedCountryISO]="CountryISO.Bulgaria"
                                                  [maxLength]="15"
                                                  [phoneValidation]="true"
                                                  [separateDialCode]="true"
                                                  [customPlaceholder]="'Въведете тел. номер'"
                                                  formControlName="phoneNumber">
                              </ngx-intl-tel-input>

                              <button type="button"
                                      class="btn btn-primary"
                                      [disabled]="isEditMode"
                                      (click)="onUserSearchClicked()">
                                {{ phoneFieldEnabled ? "Търси" : "Изчисти" }}
                              </button>

                            </div>
                          </div>
                        </div>
                        <div class="row g_3 mb-3">
                          <div class="col-md-4 col-sm-12">
                            <label class="col-form-label">Име:</label>
                            <input class="form-control"
                                   type="text"
                                   formControlName="firstName"
                                   placeholder="Въведете име" />
                          </div>
                          <div class="col-md-4 col-sm-12">
                            <label class="col-form-label">Презиме</label>
                            <input class="form-control"
                                   type="text"
                                   formControlName="middleName"
                                   placeholder="Въведете презиме" />
                          </div>
                          <div class="col-md-4 col-sm-12">
                            <label class="col-form-label">Фамилия</label>
                            <input class="form-control"
                                   type="text"
                                   formControlName="lastName"
                                   placeholder="Въведете фамилия" />
                          </div>
                          <div class="col-md-4 col-sm-12">
                            <label class="col-form-label">Емайл</label>
                            <input class="form-control"
                                   type="text"
                                   formControlName="email"
                                   placeholder="Въведете Емайл" />
                          </div>
                        </div>
                        <div class="row mb-3">
                          <div class="col-md-12 col-sm-12">

                            <label for="responseType">Вид Обратна Връзка</label>
                            <select class="form-select" formControlName="responseType">
                              <ng-container *ngFor="let r of responseTypes">
                                <option [ngValue]="r.key">
                                  {{ getCyrilicRequestType(r.key) }}
                                </option>
                              </ng-container>
                            </select>

                          </div>
                        </div>

                        <hr class="mt-4 mb-4" />
                      </div>
                    </section>
                  </ng-container>

                  <!-- Signal description form fields -->
                  <h4>Описание на инцидента</h4>
                  <div class="mb-3">
                    <label class="col-form-label">Заглавие: </label>
                    <input class="form-control"
                           type="text"
                           formControlName="title"
                           placeholder="Въведете Заглавие" />
                  </div>
                  <div *ngIf="registeredSignal" class="mb-3">
                    <label class="col-form-label">Статус: </label>
                    <input class="form-control"
                           disabled="disabled"
                           type="text"
                           value="{{getStatus()}}"
                           placeholder="Въведете Заглавие" />

                  </div>
                  <div class="mb-3">
                    <label class="col-form-label">Тип на аварията: <span class="font-danger">*</span></label>
                    <select formControlName="avariaType" class="form-select">
                      <option [ngValue]="null" disabled>
                        Изберете тип на аварията от падащия списък
                      </option>
                      <ng-container *ngFor="let item of avariaTypesList">
                        <ng-container *ngIf="item.isActive">
                          <option [ngValue]="item.id">{{ item.title }}</option>
                        </ng-container>
                      </ng-container>
                    </select>
                  </div>

                  <!-- Working group. Only in edit mode and for non false signals -->
                  <ng-container *ngIf="!isFalseSignal && isEditMode">
                    <div class="focus-container mb-3" [class.focus-container]="isUserTechnicalManager">
                      <label class="col-form-label">Ремонта Група: <span class="font-danger">*</span></label>
                      <select formControlName="wGroup" class="form-select" [disabled]="!isUserTechnicalManager">
                        <ng-container *ngFor="let item of wGroups">
                          <ng-container *ngIf="item.isActive">
                            <option [ngValue]="item.id">{{GetRemGroupaTitle(item)}}</option>
                          </ng-container>
                        </ng-container>
                      </select>
                    </div>
                  </ng-container>

                  <div class="mb-3">
                    <label class="col-form-label">
                      Дата и час на устанояване на инцидента
                      <span class="font-danger">*</span>
                    </label>
                    <input class="form-control"
                           formControlName="whenDateTime"
                           type="datetime-local"
                           placeholder="" />
                  </div>
                  <div class="mb-3">
                    <label class="col-form-label">Описание на инцидента</label>
                    <textarea rows="5"
                              cols="5"
                              placeholder="Въведете допълнително описание"
                              class="form-control"
                              formControlName="description"
                              spellcheck="false">
          </textarea>
                  </div>
                  <div class="mb-3" style="display: none">
                    <label class="col-form-label">Прикачени файлове към инцидента</label>
                    <ngx-dropzone (change)="onFilesSelect($event)"
                                  [multiple]="true">
                      <ngx-dropzone-label>
                        <div>
                          <div class="dz-message needsclick">
                            <i class="icon-cloud-up"></i>
                            <h6>Drop files here or click to upload.</h6>
                            <span class="dz-message needsclick">
                              (This is just a demo dropzone. Selected files are
                              <strong>not</strong> actually uploaded.)
                            </span>
                          </div>
                        </div>
                      </ngx-dropzone-label>
                      <ngx-dropzone-preview *ngFor="let f of files"
                                            [removable]="true"
                                            (removed)="onFileRemove(f)">
                        <ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
                      </ngx-dropzone-preview>
                    </ngx-dropzone>
                  </div>

                  <hr class="mt-4 mb-4" />
                  <h4>Местоположение на аварията</h4>
                  <label class="col-form-label">Изберете локация на аварията <span class="font-danger">*</span></label>
                  <div class="map-container-wrapper mb-3">
                    <app-map-location-selector [readonly]="!this.isUserDispatcher"
                                               [location]="incidentLocation"
                                               [zoom]="16"
                                               (locationUpdated)="onLocationUpdated($event)">
                    </app-map-location-selector>
                  </div>

                  <!-- Request for phisical check at the location  -->
                  <ng-container *ngIf="isUserRepairGroupManager">

                    <hr class="mt-4 mb-4" />
                    <h4 class="pb-3 mb-0">Организиране на физическа проверка</h4>
                    <div class="mb-3" [class.focus-container]="registeredSignal.signalStatusId !== signalStatusTypes.CHECKING">
                      <label class="col-form-label">Дата и час на извършване на проверка: <span class="font-danger">*</span></label>
                      <input class="form-control"
                             formControlName="checkoutWhen"
                             type="datetime-local"
                             placeholder="" />

                      <label class="col-form-label mt-3">Допълнително разяснение:</label>
                      <textarea rows="5"
                                cols="5"
                                placeholder="Въведете допълнително разяснение"
                                class="form-control"
                                formControlName="checkoutAdittionalInfo"
                                spellcheck="false">
            </textarea>
                    </div>

                    <ng-container *ngIf="registeredSignal.signalStatusId === signalStatusTypes.CHECKING">
                      <hr class="mt-4 mb-4" />
                      <h4 class="pb-3 mb-0">Финализиране на сигнала</h4>
                      <div class="mb-3" [class.focus-container]="registeredSignal.signalStatusId === signalStatusTypes.CHECKING">
                        <label class="col-form-label mt-3">Финално заключение:</label>
                        <textarea rows="5"
                                  placeholder="Въведете допълнително разяснение"
                                  class="form-control"
                                  formControlName="checkoutAdittionalInfo2"
                                  spellcheck="false">
              </textarea>
                      </div>
                    </ng-container>
                  </ng-container>
                </app-modal-body>

                <app-modal-footer>
                  <div class="footer-wrapper">
                    <ng-container *ngIf="isUserDispatcher">
                      <ng-container *ngIf="!isEditMode">
                        <button type="submit"
                                [name]="positiveSignalStatus.id"
                                class="btn btn-primary"
                                [disabled]="!form.valid">
                          {{ positiveSignalStatus.title }}
                        </button>
                        <button type="submit"
                                [name]="falseSignalStatus.id"
                                class="btn btn-secondary ms-2"
                                [disabled]="!form.valid">
                          {{ falseSignalStatus.title }}
                        </button>
                      </ng-container>
                      <ng-container *ngIf="isEditMode">
                        <button type="submit"
                                [name]="positiveSignalStatus.id"
                                class="btn btn-primary"
                                [disabled]="!form.valid">
                          Запази промените
                        </button>
                      </ng-container>
                    </ng-container>
                    <ng-container *ngIf="isUserTechnicalManager">
                      <div class="row">
                        <div class="col">
                          <button type="submit"
                                  name="workingGroup"
                                  class="btn btn-primary"
                                  [disabled]="!form.valid">
                            Задаване на Ремонта група
                          </button>
                        </div>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="isUserRepairGroupManager">
                      <div class="row">
                        <div class="col">
                          <ng-container *ngIf="registeredSignal.signalStatusId !== signalStatusTypes.CHECKING">
                            <button type="submit"
                                    name="{{formPhysicalCheckBtnName}}"
                                    class="btn btn-primary"
                                    [disabled]="!form.valid">
                              Задаване на физическа проверка
                            </button>
                          </ng-container>
                          <ng-container *ngIf="registeredSignal.signalStatusId === signalStatusTypes.CHECKING">
                            <div class="d-flex flex-row gap-3 justify-content-end">
                              <button type="submit"
                                      name="{{formRegisterIncidentBtnName}}"
                                      class="btn btn-primary"
                                      [disabled]="!form.valid">
                                <i class="fa fa-bug"></i> Регистриране на авария
                              </button>
                              <button type="submit"
                                      name="{{formNoIncidentBtnName}}"
                                      class="btn btn-outline-primary"
                                      [disabled]="!form.valid">
                                Липса на авария
                              </button>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </app-modal-footer>
              </ng-template>
            </li> 
            <li [ngbNavItem]="2">
              <a ngbNavLink>История</a>
              <ng-template ngbNavContent>
                <app-general-history [history]="generalHistory" ></app-general-history>
              </ng-template>
            </li>
          </ul>
          <div [ngbNavOutlet]="nav" class="mt-4"></div>
        </div>
      </div>


    </form>
  </app-modal>
</ng-template>
